import { z } from 'zod';

export const ProblemJson = z.object({
  type: z.string().url().optional(),
  title: z.string(),
  status: z.number().int(),
  detail: z.string().optional(),
  instance: z.string().optional(),
});
export type ProblemJson = z.infer<typeof ProblemJson>;
